import React from "react";
import { Card, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../AdminDashboardSlice";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";

const AdminDashboardFilters = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((s) => s.adminDashboard);

  const handleChange = (fromDate, toDate) => {
    dispatch(setFilters({ fromDate, toDate }));
  };

  return (
    <Card className="mb-4">
      <Row gutter={16}>
        <CommonDateRangeFilter
          filters={filters}
          onChange={handleChange}
        />
      </Row>
    </Card>
  );
};

export default AdminDashboardFilters;